import React from "react";

const dashboard = () => {
  return (
    <div>
      <h4>Dashboard</h4>
    </div>
  );
};

export default dashboard;
